
export const keyCodes = {
	enter: 13,
	escape: 27,
	space: 32,
	arrowUp: 38,
	arrowDown: 40,
	comma: 188,
};
